import "./AlertModal.css";

function AlertModal({ show, message, onClose }) {

  if (!show) return null;

  return (

    <div className="alert-overlay">

      <div className="alert-box">

        <div className="alert-icon">
          ⚠️
        </div>

        <h2>Error</h2>

        <p>{message}</p>

        <button
          onClick={onClose}
          className="alert-button"
        >
          OK
        </button>

      </div>

    </div>

  );

}

export default AlertModal;